import { ConnectionVersion } from '../../constants/common.constants';

export enum BlueprintType {
    EVENT = 'EVENT',
    MEETING = 'MEETING',
    CONNECTION = 'CONNECTION',
    ORDER = 'ORDER'
}

export enum BlueprintFieldType {
    FORM_PREFILL = 'FORM_PREFILL',
    PASSPORT_SITE_ACTION_INPUT = 'PASSPORT_SITE_ACTION_INPUT',
    CONNECTION_ACTION_INPUT = 'CONNECTION_ACTION_INPUT',
    CONNECTION_GROUP_ACTION_INPUT = 'CONNECTION_GROUP_ACTION_INPUT',
    SINGLE_MEETING_ACTION_INPUT = 'SINGLE_MEETING_ACTION_INPUT',
    SINGLE_MEETING_PAGE_ACTION_INPUT = 'SINGLE_MEETING_PAGE_ACTION_INPUT',
    SINGLE_MEETING_CONNECTIONS_ACTION_INPUT = 'SINGLE_MEETING_CONNECTIONS_ACTION_INPUT',
    PODIUM_LINK_ACTION_INPUT = 'PODIUM_LINK_ACTION_INPUT',
    ROLE_CONNECTION_ACTION_INPUT = 'ROLE_CONNECTION_ACTION_INPUT',
}

export enum PASSPORT_URL_YEAR_FORMATS {
    SHORT_YEAR_FORMAT = 'EVENT_NAME_MMM_YY',
    LONG_YEAR_FORMAT = 'EVENT_NAME_MMM_YYYY',
}

export interface BlueprintField {
    name: string;
    type: BlueprintFieldType;
    value: unknown;
}

export enum ActionType {
    PASSPORT_SITE = 'PASSPORT_SITE',
    CONNECTION_TYPE = 'CONNECTION',
    SINGLE_MEETING = 'SINGLE_MEETING',
    SINGLE_MEETING_CUSTOM_PAGE = 'SINGLE_MEETING_CUSTOM_PAGE',
    SINGLE_MEETING_CONNECTIONS = 'SINGLE_MEETING_CONNECTIONS',
    PODIUM_LINK = 'PODIUM_LINK',
}

export interface Action {
    order: number;
    type: ActionType;
}

export interface IBlueprintDTO {
    accountId: number;
    blueprintId: string;
    type: BlueprintType;
    name: string;
    description?: string;
    createdAt: string;
    updatedAt?: string;
    fields: BlueprintField[];
    actions?: Action[];
    connectionVersion?: ConnectionVersion;
    orderBookingSubset?: string[];
    externalId?: string | null;
}

export interface IOrderBookingBlueprintDTO {
    blueprintId: string;
    accountId: number;
    type: BlueprintType;
    orderBookingSubset?: string[];
    participantLinkType: string;
    publicDescription: string;
    publicName: string;
    orderBookingEnabled: boolean;
    eventAttributeIds?: number[];
}